import { LocalStorageService } from "@/Application/core/services/localStorageService";
import { useRef } from "react";

export const useRestorePagePosition = () => {

    const timeHolder = useRef<any>()

    const savePosition = () => {
        const locastorageService = new LocalStorageService();
        locastorageService.write('pageYPosition', window.scrollY)
    }

    const clearPosition = () => {
        const locastorageService = new LocalStorageService();
        locastorageService.deleteItem('pageYPosition')
    }

    const restore = (delay = 200) => {
        const locastorageService = new LocalStorageService();
        let position = locastorageService.read('pageYPosition')
        if (!position && isNaN(Number(position))) {
            position = 0
        }

        if (timeHolder.current) clearTimeout(timeHolder.current)
        timeHolder.current = setTimeout(() => {
            window.scrollTo({
                left: 0,
                top: position,
                behavior: 'smooth'
            })
        }, delay);
    }

    return {
        savePosition,
        clearPosition,
        restore
    }

}